import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { AuthShell } from "@/pages/authShared";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) { toast.error(apiError(err)); } finally { setLoading(false); }
  };

  return (
    <AuthShell title="Mot de passe oublié" subtitle="Nous vous enverrons un lien de réinitialisation."
      footer={<Link to="/connexion" className="text-terracotta hover:underline">Retour à la connexion</Link>}>
      {sent ? (
        <p className="text-sm text-ink-muted text-center">Si un compte existe pour cet e-mail, un lien de réinitialisation vient d'être envoyé. Pensez à vérifier vos spams.</p>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <div><Label htmlFor="email">E-mail</Label><Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="bg-sand border-line mt-1" data-testid="forgot-email" /></div>
          <Button type="submit" disabled={loading} className="w-full bg-terracotta hover:bg-terracotta-dark text-white rounded-md" data-testid="forgot-submit">{loading ? "Envoi…" : "Envoyer le lien"}</Button>
        </form>
      )}
    </AuthShell>
  );
}
